export const consumirIntencionNuevo = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.get("nuevo") !== "1") return false;

  url.searchParams.delete("nuevo");
  const query = url.searchParams.toString();
  const destino = `${url.pathname}${query ? `?${query}` : ""}${url.hash}`;
  window.history.replaceState(window.history.state, "", destino);
  return true;
};

const PRODUCTO_BORRADOR_KEY = "lainternacional_producto_borrador";

export const guardarBorradorProducto = (producto) => {
  sessionStorage.setItem(PRODUCTO_BORRADOR_KEY, JSON.stringify(producto));
};

export const consumirBorradorProducto = () => {
  const raw = sessionStorage.getItem(PRODUCTO_BORRADOR_KEY);
  sessionStorage.removeItem(PRODUCTO_BORRADOR_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
